import type { Locale, QueryParams, CommerceContext as Context } from "@agapi/mlc-core";
import type { Loop54ClientConfig } from "../loop54/client";
import type { AutoCompleteResponse, Response } from "../loop54/types";
import { autocomplete, search } from "../loop54";
import { getBaseFilter, getFacets } from "./general";

export const doSearch = async <CUSTOM_PARAMS, CUSTOM_DATA>(config: Loop54ClientConfig, params: QueryParams, locale: Locale, context: Context, customData: CUSTOM_PARAMS) => {
  const calls: Array<Promise<{ identifier: 'search'; response: Response<CUSTOM_DATA> } | { identifier: 'autoComplete', response: AutoCompleteResponse }>> = [];

  calls.push(new Promise(async (resolve) => {
    const response = await search<CUSTOM_PARAMS, CUSTOM_DATA>(
      config.fetch,
      locale,
      {
        query: params.query,
        userId: context.userId,
        resultsOptions: {
          ...getBaseFilter(params, locale, config),
          ...getFacets(params),
          take: params.limit,
          skip: params.offset,
          sortBy: params.sortBy
        },
        customData,
        config: { ...config, locale }
      }
    );
    return resolve({ identifier: 'search', response: response });
  }));

  if (params.includeAutoComplete) {
    calls.push(new Promise(async (resolve) => {
      const response = await autocomplete(
        config.fetch,
        locale,
        {
          query: params.query,
          customData: { directSearch: true },
          userId: context.userId,
          config: { ...config, locale }
        }
      );
      return resolve({ identifier: 'autoComplete', response: response });
    }));
  }

  const result = await Promise.allSettled(calls);
  console.log('[doSearch] result', result);
  return result.reduce<{ search: Response<CUSTOM_DATA>; autoComplete: AutoCompleteResponse; }>((a, v) => {
    if (v.status === 'fulfilled') {
      if (v.value.identifier === 'search') {
        a.search = v.value.response;
      } else if (v.value.identifier === 'autoComplete') {
        a.autoComplete = v.value.response;
      }
    }
    return a;
  }, {} as any);
}
